var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-card",class:{
    colored: _vm.$props.colored,
    checked: _vm.$props.checked,
    disabled: _vm.$props.disabled,
  },on:{"click":function($event){!_vm.$props.disabled && _vm.$emit('change', $event.target.checked)}}},[_c('input',{attrs:{"type":"radio","name":_vm.$props.name},domProps:{"checked":_vm.$props.checked}}),_vm._v(" "),_c('div',{staticClass:"radio-card__header"},[_vm._t("header"),_vm._v(" "),_c('div',{staticClass:"radio-card__radio",class:{
        checked: _vm.$props.checked,
      }})],2),_vm._v(" "),_c('div',{staticClass:"radio-card__body"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }